import React from "react";
import {Link} from "react-router-dom";
import {ReactComponent as Logo} from '../../assets/logo/Bellmeet.svg';
import Burger from "../Burger";
import {useTranslation} from "react-i18next";
import ChangeLang from "../../components/ChangeLang";

const Nav = () => {
	const { t } = useTranslation('common');
	const enableOffer = false;
	const offerCode = 'norooz1401';
	const onCopy = () => {
		navigator.clipboard.writeText(offerCode)
		alert('کد تخفیف کپی شد.')
	}
	return (
		<>
			{enableOffer ? <div className='offer-wrap'>
					<strong>30% تخفیف</strong>
 					<p>فقط تا پایان تعطیلات</p>
					<em>{offerCode}</em>
					<button onClick={onCopy}>کپی کن</button>
			</div> : '' }
			<div className="mobile tablet mobile-change-lang" style={enableOffer ? {marginTop:60} : {}}>
				<ChangeLang/>
			</div>
			<div className={'navbar-wrap'} style={enableOffer ? {marginTop:60} : {}}>
				<div className={'navbar-section navbar-link'}>
					<ul className={'nav-links-ul'}>
							<ChangeLang/>
						<li>
							<a className='navbar-login' target='_blank' rel="noreferrer"  href='https://panel.bellmeet.com'>{t('SignUp')}</a>
						</li>
						<div className="dropdown">
							<button className="dropbtn">{t('Company')}</button>
							<div className="dropdown-content">
								{t('lang') === 'fa' ? <Link to={'/why'}>{t('WhyBell')}</Link> : ""}
								<Link to={'/tools'}>{t('Facility')}</Link>
								<Link to={'/webservice'}>{t('API')}</Link>
								{t('lang') === 'fa' ? <Link to={'/about'}>{t('AboutUs')}</Link> : ""}
							</div>
						</div>
						<li>
							<Link to={'/price'}>{t('Plans')}</Link>
						</li>
						<li>
							<Link to={'/demo'}>{t('Demo')}</Link>
						</li>
						<li>
							{t('lang') === 'fa' ? <Link to={'/support'}>{t('Support')}</Link> : <Link to={'/videoEn'}>{t('Support')}</Link>}
						</li>
						<li>
							<a href="https://blog.bellmeet.com">{t('Blog')}</a>
						</li>
					</ul>
					<Burger className={'tablet'}>
						<ul>
							<li>
								<a className='navbar-login' target='_blank' rel="noreferrer"  href='https://panel.bellmeet.com'>{t('SignUp')}</a>
							</li>
							{t('lang') === 'fa' ?
								<li>
								<Link to={'/why'}>{t('WhyBell')}</Link>
								</li>
								: ""
							}
							<li>
								<Link to={'/tools'}>{t('Facility')}</Link>
							</li>
							<li>
								<Link to={'/webservice'}>{t('API')}</Link>
							</li>
							<li>
								<Link to={'/price'}>{t('Plans')}</Link>
							</li>
							<li>
								<Link to={'/demo'}>{t('Demo')}</Link>
							</li>
							<li>
								{t('lang') === 'fa' ? <Link to={'/support'}>{t('Support')}</Link> : <Link to={'/videoEn'}>{t('Support')}</Link>}
							</li>
							{t('lang') === 'fa' ?
								<li>
									<Link to={'/about'}>{t('AboutUs')}</Link>
								</li>
								: ""
							}
							<li>
								<a href="https://blog.bellmeet.com">{t('Blog')}</a>
							</li>
						</ul>
					</Burger>
				</div>
				<div className={'navbar-section logo-wrap'}>
					<Link to={'/'}><Logo/></Link>
				</div>
			</div>
		</>
	)
}

export default Nav